import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import {
  formatPrice,
  formatPercentage,
} from 'common/formatters';

import {
  DATA_TABLE_SOURCE_LOCATOR_COMMISSIONS,
  DATA_TABLE_VIEW_ID_LOCATOR_COMMISSIONS_ALL,
} from 'common/dataTableConstants';

import {
  dataTable,
  actionDataTableLoadItems,
  actionDataTableLoadNextPage,
  actionDataTableReset,
} from 'client/helpers/dataTables';

import SrTable from 'client/components/SrTable';
import withInfiniteScroll from 'client/helpers/withInfiniteScroll';

@dataTable({
  dataSource: DATA_TABLE_SOURCE_LOCATOR_COMMISSIONS,
  viewId: DATA_TABLE_VIEW_ID_LOCATOR_COMMISSIONS_ALL,
  sort: {
    createdDate: 'desc',
  },
})
@withInfiniteScroll({
  offset: 32,
})
class SrDataTableLocatorCommissions extends Component {
  static propTypes = {
    items: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
    dispatch: PropTypes.func.isRequired,
    dataTableApiState: PropTypes.object.isRequired,
    dataTableIsFullyLoaded: PropTypes.bool.isRequired,
    onInfiniteScrollWrapperRef: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);
    const { onInfiniteScrollCallbackReady } = props;
    onInfiniteScrollCallbackReady(this._infiniteScrollCallback);
  }

  _infiniteScrollCallback = () => {
    const { dataTableIsFullyLoaded, dispatch } = this.props;
    if (!dataTableIsFullyLoaded) {
      dispatch(actionDataTableLoadNextPage, {
        dataSource: DATA_TABLE_SOURCE_LOCATOR_COMMISSIONS,
        viewId: DATA_TABLE_VIEW_ID_LOCATOR_COMMISSIONS_ALL,
        count: 8,
      });
    }
  }

  _onRefreshButtonClick = () => {
    const { dispatch } = this.props;
    dispatch(actionDataTableReset, {
      dataSource: DATA_TABLE_SOURCE_LOCATOR_COMMISSIONS,
    });
  }

  _onReloadLocatorCommissionRequested = (locatorCommissionId) => {
    const { dispatch } = this.props;
    dispatch(actionDataTableLoadItems, {
      dataSource: DATA_TABLE_SOURCE_LOCATOR_COMMISSIONS,
      viewId: DATA_TABLE_VIEW_ID_LOCATOR_COMMISSIONS_ALL,
      filter: {
        id: locatorCommissionId,
      },
      count: 1,
    });
  }

  render() {
    const {
      items,
      dataTableApiState,
      onInfiniteScrollWrapperRef,
    } = this.props;

    return (
      <div ref={onInfiniteScrollWrapperRef}>
        <button
          className='floatButton refresh'
          type='button'
          onClick={this._onRefreshButtonClick}
        />
        {dataTableApiState.error && (
          <span>ERROR: { dataTableApiState.error }</span>
        )}
        <SrTable
          headers={[
            { content: 'id' },
            { content: 'locator' },
            { content: 'renter name' },
            { content: 'renter phone' },
            { content: 'lease start date' },
            { content: 'apartment' },
            { content: 'commission %' },
            { content: 'amount' },
            { content: 'stripe payment id' },
            { content: 'status' },
            { content: 'created date' },
            { content: 'due date' },
            { content: 'rent price' },
            { content: 'lease notes' },
            { content: 'lease id' },
            { content: 'commission structure id' },
          ]}
          rows={items.map((locatorCommission) => ({
            cells: [
              { content: locatorCommission.id },
              { content: locatorCommission.locatorName },
              { content: locatorCommission.renterName },
              { content: locatorCommission.renterPhone },
              { content: moment(locatorCommission.leaseStartDate).format('MMM Do, YYYY') },
              { content: locatorCommission.apartmentName || '--' },
              { content: formatPercentage(locatorCommission.calculatedLocatorCut) },
              { content: formatPrice(locatorCommission.amount) },
              { content: locatorCommission.stripePaymentId || '--' },
              { content: locatorCommission.status },
              { content: moment(locatorCommission.createdDate).format('MMM Do, YYYY') },
              { content: moment(locatorCommission.dueDate).format('MMM Do, YYYY') },
              { content: formatPrice(locatorCommission.rentPrice) },
              { content: locatorCommission.leaseNotes },
              { content: locatorCommission.leaseId },
              { content: locatorCommission.commissionStructureId },
            ],
          }))}
        />
        {dataTableApiState.inProgress && (
          <div className='loading-ellipses left' />
        )}
      </div>
    );
  }
}

SrDataTableLocatorCommissions.displayName = 'SrDataTableLocatorCommissions';

export default SrDataTableLocatorCommissions;
